import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "../S1_Header/menu";

import S6_Footer from "../S6_Footer";

const VideoBK = styled.video`
  height: auto;
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;

const Wrapper = styled.div`
  background: rgb(0 0 0 / 5%);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1;
`;
const A = styled.a``;
const Contact = styled.button`
  margin: 30px 0 0 0;
  border: none;

  background: linear-gradient(to right, #ff3ffd, #fed900);
  color: #ffffff;
  padding: 7px 30px;
  border-radius: 30px;

  cursor: pointer;
  text-decoration: none;
`;

const index = () => {
  return (
    <div>
     
      <VideoBK autoPlay loop muted>
        <source src="/images/hapebg.mp4" type="video/mp4" />
      </VideoBK>
      <Wrapper>
        <Menu />
        <SectionWrapper pt="0px" id="explore" pb650px="10px">
          <Container>
            <SectionSmallHeading p="130px 0 0 0">About</SectionSmallHeading>
            <SectionHeading>JOIN THE $HAPE MOVEMENT</SectionHeading>
            <P maxWidth="70%">
              We aim to build a tribe of apes with the goal to launch the next
              100X ape worthy memecoin that is both safe and profitable for all
              #HAPES!
              <br />
              <br />
              $HAPE will use a % of each buy and sell to continuously pump the
              chart via buybacks and burn the supply which will raise the price
              per token, thus increasing the marketcap! Basically, this will
              pump every apes bag nonstop until the end of time! <br />
              <br />
              Join our #HAPE movement and let’s rise together to create history
              as one unified #HAPE tribe!
            </P>

            <A href="mailto:info@hexape.finance" target="blank">
              <Contact>Contact Us</Contact>
            </A>
          </Container>
        </SectionWrapper>
        <S6_Footer />
      </Wrapper>
    </div>
  );
};

export default index;
